import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import AddIcon from '@material-ui/icons/Add';
import {
  CircularProgress,
  List,
  TablePagination,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
} from '@material-ui/core';
import styles from './styles.module.css';
import api from '../../core/api';
import AddNewUser from '../../components/AddUser';
import Empresas from '../../models/Empresas';

import {KeyboardDatePicker} from '@material-ui/pickers';
import Business from '../../models/Business';
import UserBusinessItem from '../../components/UserBusinessItem';
import {GetData} from '../../utils/Storage';
import Confirm from '../../components/Confirm';
import {useSnackbar} from 'notistack';
import ButtonExport from './buttonExport';

export const GetSubscriptionType = premium => {
  switch (premium) {
    case 'F':
      return 'Free';
    case 'M':
      return 'Mensal';
    case 'Y':
      return 'Anual';
    case 'N':
      return 'New';
    case 'G':
      return 'Gift';
    case 'S':
      return 'Parceiro Especial';
    default:
      return premium;
  }
};

const style = {
  flexEnd: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  datePicker: {
    width: 'fit-content',
    border: 'solid 1px #d3d3d3',
    borderRadius: '4px',
  },
};

const UsersBusinessPage = ({history}) => {
  const user = GetData('business');
  const [users, setUsers] = useState([]);
  const [getEmpresas, setEmpresas] = useState([]);
  const [getSpecial, setSpecial] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [isLoading, setIsFirstLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filterValue, setFilterValue] = useState('');
  const [selectEmpresa, setSelectEmpresa] = useState('');
  const [subscriptionType, setSubscriptionType] = useState('');
  const [b2bFilter, setB2bFilter] = useState('');
  const [newsletterType, setNewsletterType] = useState();
  const [onboardingUser, setOnboardingUser] = useState();
  const [activeUser, setActiveUser] = useState();
  const [platform, setPlatform] = useState();
  const [adminSelect, setAdminSelect] = useState(false);
  const [startDate, setStartDate] = useState(
    new Date(new Date().setFullYear(2015)),
  );
  const [endDate, setEndDate] = useState(new Date());
  const [error, setError] = useState(false);

  const {enqueueSnackbar} = useSnackbar();
  const [selectedEmails, setSelectedEmails] = useState([]);
  const toggleEmail = email => {
    setSelectedEmails(prev =>
      prev.includes(email) ? prev.filter(e => e !== email) : [...prev, email],
    );
  };

  const removeSelected = async () => {
    if (selectedEmails.length === 0) return;

    const confirmar = await Confirm(
      `Deseja realmente remover ${selectedEmails.length} usuários do B2B?`,
    );

    if (confirmar) {
      setIsFirstLoading(true);
      try {
        await api.post('/business_users/unlink', {emails: selectedEmails});
        enqueueSnackbar('Usuários desvinculados com sucesso!', {
          variant: 'success',
        });
        fetchUsers();
        setSelectedEmails([]);
      } catch (err) {
        enqueueSnackbar('Erro ao desvincular usuários', {variant: 'error'});
        console.error(err);
      } finally {
        setIsFirstLoading(false);
      }
    }
  };

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleFilterChange = event => {
    setFilterValue(event.target.value);
    setCurrentPage(1);
  };

  const handleSubscriptionTypeChange = event => {
    setSubscriptionType(event.target.value);
    setB2bFilter('');
    setCurrentPage(1);
  };

  const handleB2bTypeChange = event => {
    setB2bFilter(event.target.value);
    setCurrentPage(1);
  };

  const handleNewsletterTypeChange = event => {
    setNewsletterType(event.target.value);
    setCurrentPage(1);
  };

  async function fetchUsers() {
    if (users.length < 1) {
      setFirstLoading(true);
    }
    setIsFirstLoading(true);
    const filters = {
      name: filterValue,
      isAdmin: adminSelect,
      premium: subscriptionType,
      newsletter: newsletterType,
      onboarding: onboardingUser,
      activeUser: activeUser,
      platform: platform,
      business_id: b2bFilter,
      business_user: true,
      business_user_manager: false,
      company: selectEmpresa,
      startDate,
      endDate,
    };

    await api
      .get('users', {
        params: {
          page: currentPage,
          pageSize,
          filters,
          subscriptionType,
          searchInactive: true
        },
      })
      .then(async ({data}) => {
        console.log(data.users, 'data')
        setUsers(data.users);
        setTotalPages(data.totalUsers);
      })
      .catch(err => {
        setError(true);
      })
      .finally(() => {
        setError(false);
        setFirstLoading(false);
        setIsFirstLoading(false);
      });
  }

  const fetchSpecial = async () => {
    try {
      const allSpecials = await Business.findAll();
      setSpecial(allSpecials);
    } catch (e) {
      console.log({e});
    }
  };

  const fetchEmpresa = async () => {
    try {
      const allEmpresas = await Empresas.findAll();
      setEmpresas(allEmpresas);
    } catch (e) {
      // console.log({e});
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [
    currentPage,
    pageSize,
    filterValue,
    subscriptionType,
    b2bFilter,
    adminSelect,
    newsletterType,
    onboardingUser,
    activeUser,
    platform,
    selectEmpresa,
    startDate,
    endDate,
  ]);

  useEffect(() => {
    fetchEmpresa();
    fetchSpecial();
  }, []);

  if (error) {
    return (
      <div>
        <p style={{textAlign: 'center'}}>Ocorreu um erro ao obter os dados.</p>
        <p style={{textAlign: 'center'}}>
          <a href="javascript:void(0)" onClick={fetchUsers}>
            Tentar novamente
          </a>
        </p>
      </div>
    );
  }

  return (
    <Dashboard>
      <div style={{overflow: 'hidden'}}>
        <div className={styles['filter-bar']}>
          <TextField
            variant="outlined"
            label="Buscar usuário"
            value={filterValue}
            onChange={handleFilterChange}
          />
          {user.adminMaster && (
            <FormControl>
              <InputLabel
                id="subscription-type-label"
                style={{paddingLeft: '15px'}}>
                Empresa
              </InputLabel>
              <Select
                labelId="subscription-type-label"
                className={styles.select}
                variant="outlined"
                placeholder=""
                value={b2bFilter}
                onChange={handleB2bTypeChange}>
                <MenuItem value="">Todos</MenuItem>
                {getSpecial &&
                  getSpecial.map(e => {
                    return <MenuItem value={e.id}>{e.corporateName}</MenuItem>;
                  })}
              </Select>
            </FormControl>
          )}
          <FormControl>
            <InputLabel
              id="subscription-type-label"
              style={{paddingLeft: '15px'}}>
              Receber Newsletter?
            </InputLabel>
            <Select
              labelId="subscription-type-label"
              className={styles.select}
              variant="outlined"
              placeholder=""
              value={newsletterType}
              onChange={handleNewsletterTypeChange}>
              <MenuItem value={undefined}>Todos</MenuItem>
              <MenuItem value={true}>Sim</MenuItem>
              <MenuItem value={false}>Não</MenuItem>
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel
              id="subscription-type-label"
              style={{paddingLeft: '15px'}}>
              Tipo de Plano
            </InputLabel>
            <Select
              labelId="subscription-type-label"
              className={styles.select}
              variant="outlined"
              placeholder=""
              value={subscriptionType}
              onChange={handleSubscriptionTypeChange}>
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="N">New</MenuItem>
              <MenuItem value="F">Free</MenuItem>
              <MenuItem value="M">Mensal</MenuItem>
              <MenuItem value="Y">Anual</MenuItem>
              <MenuItem value="G">Gift</MenuItem>
              <MenuItem value="S">Parceiro especial</MenuItem>
            </Select>
          </FormControl>
          {/* <FormControl>
            <InputLabel
              id="subscription-type-label"
              style={{paddingLeft: '15px'}}>
              Onboarding?
            </InputLabel>
            <Select
              labelId="subscription-type-label"
              className={styles.select}
              variant="outlined"
              placeholder=""
              value={onboardingUser}
              onChange={handleOnboardingChange}>
              <MenuItem value={undefined}>Todos</MenuItem>
              <MenuItem value={true}>Sim</MenuItem>
              <MenuItem value={false}>Não</MenuItem>
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel
              id="subscription-type-label"
              style={{paddingLeft: '15px'}}>
              Usuários Ativos?
            </InputLabel>
            <Select
              labelId="subscription-type-label"
              className={styles.select}
              variant="outlined"
              placeholder=""
              value={activeUser}
              onChange={handleUsersActiveChange}>
              <MenuItem value={undefined}>Todos</MenuItem>
              <MenuItem value={true}>Sim</MenuItem>
              <MenuItem value={false}>Não</MenuItem>
            </Select>
          </FormControl> */}
          <FormControl>
            <div style={style.datePicker}>
              <KeyboardDatePicker
                placeholder="Selecione data inicial"
                value={startDate}
                onChange={dateForm => {
                  setStartDate(new Date(dateForm));
                }}
                format="DD/MM/YYYY"
              />
            </div>
          </FormControl>
          <FormControl>
            <div style={style.datePicker}>
              <KeyboardDatePicker
                placeholder="Selecione data final"
                minDate={startDate}
                value={endDate}
                onChange={dateForm => {
                  setEndDate(new Date(dateForm));
                }}
                format="DD/MM/YYYY"
              />
            </div>
          </FormControl>
          <div>
            <Button
              sx={{borderRadius: 10}}
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => history.push(`${window.location.pathname}/add`)}>
              Adicionar Usuário
            </Button>
          </div>
          <div>
            <Button
              sx={{borderRadius: 10}}
              variant="contained"
              color="secondary"
              onClick={() =>
                history.push(`${window.location.pathname}/delete`)
              }>
              Excluir
            </Button>
          </div>
          <div>
            <Button
              sx={{borderRadius: 10}}
              variant="contained"
              color="secondary"
              onClick={removeSelected}
              disabled={selectedEmails.length === 0}>
              Excluir Selecionados
            </Button>
          </div>
          <ButtonExport 
            filterValue={filterValue}
            subscriptionType={subscriptionType}
            b2bFilter={b2bFilter}
            adminSelect={adminSelect}
            newsletterType={newsletterType}
            onboardingUser={onboardingUser}
            activeUser={activeUser}
            platform={platform}
            selectEmpresa={selectEmpresa}
            startDate={startDate}
            endDate={endDate} 
          />
        </div>

        {firstLoading ? (
          <div className="flex-col center-a center-b" style={{height: '50vh'}}>
            <span style={{paddingTop: '10em'}}>
              <CircularProgress size={100} />
              <p> Carregando... </p>
            </span>
          </div>
        ) : (
          <div>
            <TablePagination
              component="div"
              count={totalPages}
              page={currentPage - 1}
              labelRowsPerPage={'Itens por página:'}
              onChangePage={handleChangePage}
              rowsPerPage={pageSize}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            {isLoading ? (
              <div
                className="flex-col center-a center-b"
                style={{height: '50vh'}}>
                <span style={{paddingTop: '10em'}}>
                  <CircularProgress size={100} />
                  <p> Carregando... </p>
                </span>
              </div>
            ) : (
              <>
                <div style={{marginBottom: 20}} />
                <List>
                  {users.map(client => (
                    <UserBusinessItem
                      key={client.id}
                      history={history}
                      user={client}
                      fetchUsers={fetchUsers}
                      toggleEmail={toggleEmail}
                      isSelected={selectedEmails.includes(client.email)}
                    />
                  ))}
                </List>
              </>
            )}
            <TablePagination
              style={{
                marginBottom: '20px',
              }}
              component="div"
              count={totalPages}
              page={currentPage - 1}
              labelRowsPerPage={'Itens por página:'}
              onChangePage={handleChangePage}
              rowsPerPage={pageSize}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
        )}
      </div>
    </Dashboard>
  );
};

export default UsersBusinessPage;
